"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NotificationPreferenceSubSection = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const frontend_infra_localisation_1 = require("@forto-dev/frontend-infra-localisation");
const notification_center_models_1 = require("@forto-dev/notification-center-models");
const silhouette_core_1 = require("@freighthub/silhouette-core");
const NotificationPreferenceItem_1 = require("../../../features/NotificationsSettings/components/NotificationPreferenceItem");
const types_1 = require("../../../features/NotificationsSettings/types");
const translations_1 = require("../types/translations");
const useStyles = (0, silhouette_core_1.makeStyles)({
    container: {
        overflow: 'auto',
    },
});
const NotificationPreferenceSubSection = ({ data, state, disableChanges, updatePreferences, }) => {
    const classes = useStyles();
    const { translate } = (0, frontend_infra_localisation_1.useI18n)();
    if (!data)
        return null;
    const isWebEnabledForSome = data.some((reference) => !reference.visibleChannels || (reference.visibleChannels || []).includes(notification_center_models_1.NotificationChannel.Web));
    return ((0, jsx_runtime_1.jsxs)(silhouette_core_1.Box, { className: classes.container, children: [!!data[0]?.subCategory && ((0, jsx_runtime_1.jsx)(silhouette_core_1.Box, { pt: 2, ml: 1.5, children: (0, jsx_runtime_1.jsx)(silhouette_core_1.Typography, { variant: "subtitle1", children: translate(translations_1.subCategoryTranslations[data[0]?.subCategory]) }) })), data.map((itemData) => {
                const referenceArray = (0, types_1.getReferences)(itemData);
                if (!referenceArray[0])
                    throw new Error('Missing reference');
                return ((0, jsx_runtime_1.jsx)(NotificationPreferenceItem_1.NotificationPreferenceItem, { itemData: itemData, options: state[referenceArray[0]], setOptions: (itemOptions) => updatePreferences(referenceArray.map((reference) => ({ reference, ...itemOptions }))), alignOptions: isWebEnabledForSome, disableChanges: disableChanges }, referenceArray.join('-')));
            })] }));
};
exports.NotificationPreferenceSubSection = NotificationPreferenceSubSection;
//# sourceMappingURL=NotificationPreferenceSubSection.js.map